import React from 'react';
import useOperationalStore from '../platform/store/useOperationalStore';

export default function FullscreenBtn({ className = '' }) {
  const isFs = useOperationalStore(s => s.isViewFullscreen);
  const setFs = useOperationalStore(s => s.setViewFullscreen);

  function toggle() {
    if (!isFs) {
      document.documentElement.requestFullscreen?.().catch(() => {});
      setFs(true);
    } else {
      document.exitFullscreen?.().catch(() => {});
      setFs(false);
    }
  }

  return (
    <button
      className={`fsbtn${className ? ` ${className}` : ''}`}
      onClick={toggle}
      title={isFs ? 'Exit fullscreen (Esc)' : 'Fullscreen — hides sidebar and header'}
    >
      {isFs ? (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 3v3a2 2 0 0 1-2 2H3"/><path d="M21 8h-3a2 2 0 0 1-2-2V3"/>
          <path d="M3 16h3a2 2 0 0 1 2 2v3"/><path d="M16 21v-3a2 2 0 0 1 2-2h3"/>
        </svg>
      ) : (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/>
          <path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/>
        </svg>
      )}
    </button>
  );
}
